import { generateObjectFromKeys } from "@vahak/core-ui/dist/methods";

const listOfKeys = [
    "none",
    "blockUnblockUser",
    "editOperations",
    "editRoles",
    "profileEdit",
    "profileView",
    "readOperations",
    "readRoles",
    "tagAgent",
    "tagAgentManagerUI",
    "tagAgentTsoLoad",
    "tagAgentTsoLorry",
    "ticketAadhar",
    "ticketAssuredLoadAdmin",
    "ticketAssuredLoad",
    "ticketBidCancellation",
    "ticketCompanyRegistration",
    "ticketCallMeBack",
    "ticketEway",
    "ticketGST",
    "ticketPAN",
    "ticketPhysicalVerification",
    "ticketRC",
    "ticketRefundRequest",
    "ticketVerifiedLoad1",
    "postPlacementAdminView",
    "postPlacementView",
    "ticketPPPlacement",
    "ticketPPLoading",
    "ticketPPUnloading",
    "userLoadLorryAction",
    "userPhoneNumberVisibilityUI",
    "tsoBulkTagging",
    "paymentReports",
    "metaBaseReport",
    "paymentCIReports",
    "bdOpsOperation",
    "ticketVasCargo",
    "ticketVasGps",
    "ticketTsoCompanyLeads",
    "ticketMembershipCallMeBack",
    "ticketHelp",
    "ticketAccountDeletion",
    "ticketLoadVerification",
    "ticketLoadVerificationAdmin"
] as const;

export const ADMIN_OPERATION = {
    ...generateObjectFromKeys(listOfKeys)
};

export const ADMIN_OPERATION_LIST = Object.keys(ADMIN_OPERATION);
